import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M19 12.9985H17V15.9985H14V17.9985H17V20.9985H19V17.9985H22V15.9985H19V12.9985Z" fill="#00011B"/>
<path d="M12 18H6L2 22L2.01 4C2.01 2.9 2.9 2 4 2H20C21.1 2 22 2.9 22 4V14H20V4H4V17.17L5.17 16H12V18ZM6 12H14V14H6V12ZM6 9H18V11H6V9ZM6 6H18V8H6V6Z" fill="#00011B"/>
</svg>
;
